
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square6 = createMeisterIcons("square-6", [["path",{"fill":"currentColor","d":"M3.75 7c0-1.886 1.364-3.25 3.25-3.25h10A3.26 3.26 0 0 1 20.25 7v1.15H3.75zm0 2.65V17A3.26 3.26 0 0 0 7 20.25h.25V9.65zM17 20.25H8.75v-4.6h11.5V17A3.26 3.26 0 0 1 17 20.25m3.25-6.1H8.75v-4.5h11.5zM7 2.25C4.286 2.25 2.25 4.286 2.25 7v10A4.76 4.76 0 0 0 7 21.75h10A4.76 4.76 0 0 0 21.75 17V7A4.76 4.76 0 0 0 17 2.25z","key":"a366b57517290722c4b4acf84a14d8062d4ca082","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square6
  